import {
  DataCatalogResult,
  DataCatalogState,
} from 'bones/utils/store/dataCatalog/types';

export const resultLabelsByIriSelector = (state: DataCatalogState) => {
  const labelsByIri: Record<string, string> = {};
  const assignLabels = (results: Record<string, DataCatalogResult>) => {
    Object.values(results).forEach((result) => {
      labelsByIri[result.iri] = result.label || result.iri;
    });
  };
  assignLabels(state.dataSourcesByIri);
  assignLabels(state.catalogsByIri);
  assignLabels(state.schemasByIri);
  assignLabels(state.tablesByIri);
  assignLabels(state.columnsByIri);
  return labelsByIri;
};
